import React, { Component } from "react";

import cv_creator_acceuil from "./../../../img/ppe/cv_creator_acceuil.PNG";

import cv_creator_admin from "./../../../img/ppe/cv_creator_admin.PNG";
import cv_creator_inscription from "./../../../img/ppe/cv_creator_inscription.PNG";
import cv_creator_utilisateur from "./../../../img/ppe/cv_creator_utilisateur.PNG";
import cv_creator_pdf_export_import from "./../../../img/ppe/cv_creator_pdf_export_import.PNG";
import cv_creator_pdf from "./../../../img/ppe/cv_creator_pdf.PNG";
import cv_creator_creation_cv from "./../../../img/ppe/cv_creator_creation_cv.PNG";

let imagesPPE3 = [
	cv_creator_admin,
	cv_creator_inscription,
	cv_creator_utilisateur,
	cv_creator_pdf_export_import,
	cv_creator_pdf,
	cv_creator_creation_cv,
];

export default class PPE3 extends Component {
	render() {
		return (
			<>
				<div className="container">
					<div className="row mt-5">
						<div className="col-lg-12">
							<div className="section-title">
								<h2>Information</h2>
								<p>
									<b>❯ Project(s) : </b> Projet Personnel Encadré 3<br/>
									<b>❯ Technologie(s) : </b> Php, Linux, SQL, Javascript, Composer<br/>
									<b>❯ Base de données : </b> MySQL<br/>
									<b>❯ Spécialités : </b> SLAM<br/>
									<b>❯ Date : </b> 2019<br/>
									<b>❯ Lien Github : </b> <a href="https://github.com/pedrokarim/PPE3_CreationCV">Github Projet Personnel Encadré 3, Creation CV</a><br/>
								</p>
							</div>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">SLAM (Solutions Logicielles et Applications Métier)</h3>

							<h4 className="mb-20">Projet Personnel Encadré n°3, CV Creator</h4>

							<div className="row my-5">
								<div className="col-md-4">
									<a href={cv_creator_acceuil} className="img-gal">
										<img src={cv_creator_acceuil} alt="" className="img-fluid" />
									</a>
									{imagesPPE3.map(i => <a href={i} className="img-gal"> </a>)}
								</div>
								<div className="col-md-8 mt-sm-20 text-left">

									<h5>Presentation</h5><br/>
									<p>
										CV Creator est une application développée entièrement en Java et partiellement d'autres langage web pour la communication API. <br/>
										Il a été développé dans le cadre d'un projet personnel encadré du lycée Jean Lurçat en 2019.

										Il regroupe plusieurs petits projets fait en classe, donc plusieurs composants développées par les élèves (BTS SIO SLAM 2019-2020) et le but était de rassembler ce petit projet pour en faire un logiciel.
									</p>


									<h5>Principal</h5><br/>
									<p>
										Tout d'abord, le logiciel possède une interface de connexion et une interface d'inscription,
										l'interface d'inscription offre la possibilité d'utiliser les informations de comptes venant de Google <i className="fab fa-google"> </i> ou Facebook <i className="fab fa-facebook-square"> </i>. <br/>

										Une section est réservé pour le profil utilisateur, on peut modifier les informations. <br/>
										Il est possible d'exporter toutes les données de l'utilisateur vers un format de fichier de stockage par exemple XML JSON ou CSV. On peut créer des CV les modifier ou les supprimer.
										Le logiciel possède une interface d'administration pour manager des utilisateurs.
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>

			</>
		);
	}
}